var image_loading = ( function( $ ) {

	var _init = function() {
		$( '.image-wrapper.ajax-loader' ).find( 'img' ).each( _setup_image );
	};

	var _setup_image = function() {
		var src = $( this ).data( 'src' );

		$( this ).attr( 'src', src ).on( 'load', _image_loaded );
	};

	var _image_loaded = function( event ) {
		$( this ).closest( '.image-wrapper' ).addClass( 'loaded' );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = image_loading;